import { useLazyQuery } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useMemo } from 'react';

import { gql } from '../../generated';

import { useUser } from './auth/use-user';

const GET_SETTINGS = gql(/* GraphQL */ `
  query GetSettings($where: setting_bool_exp!) {
    setting(where: $where) {
      key
      value
    }
  }
`);

export const useFeatureToggle = () => {
  const { isAuth } = useUser();

  const [, { loading, data, refetch }] = useLazyQuery(GET_SETTINGS, {
    variables: {
      where: {
        key: {
          _like: 'lk.feature-toggle.%',
        },
      },
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
  });

  useEffect(() => {
    if (isAuth) {
      refetch();
    }
  }, [isAuth, refetch]);

  return {
    loading,
    featureToggle: useMemo(
      () =>
        (data?.setting.reduce((accumulator, setting) => {
          return { ...accumulator, [setting.key.replace('lk.feature-toggle.', '')]: setting.value };
        }, {}) ?? {}) as Record<string, boolean>,
      [data]
    ),
  };
};
